import { Injectable } from '@angular/core';
import {
  IField,
  IOptionValues,
} from '../../../buyer-preview/multi-section-form-preview/multi-section-form-preview.models';

@Injectable({
  providedIn: 'root',
})
export class FieldCloneService {
  constructor() {}

  cloneAnswerHTML(fieldToBeCloned: IField, newCloneOptions: IOptionValues[]) {
    const parser = new DOMParser();
    const html = parser.parseFromString(
      fieldToBeCloned?.AnswerHtml,
      'text/html'
    );
    if (['DropDownListSelection'].includes(fieldToBeCloned?.Type)) {
      Array.from(html.getElementsByTagName('select'))?.forEach(
        (selectEleTarget) => {
          const optionsArr = Array.from(
            selectEleTarget.options as HTMLOptionsCollection
          );

          optionsArr?.forEach((optTarget: HTMLOptionElement) => {
            const activeOpt = newCloneOptions.find(
              (clonedOpt: IOptionValues) =>
                optTarget.text === clonedOpt.OptionText
            );
            if (activeOpt?.UniqueID)
              optTarget.setAttribute('value', activeOpt.UniqueID);
          });
        }
      );
    } else if (['RadioButton'].includes(fieldToBeCloned?.Type)) {
      Array.from(html.getElementsByTagName('input'))?.forEach((radioTarget) => {
        const optTextVal = (radioTarget?.nextSibling as Text).data;
        const activeOpt = newCloneOptions?.find(
          (o) => o?.OptionText === optTextVal
        );
        if (activeOpt?.UniqueID)
          radioTarget.setAttribute('value', activeOpt.UniqueID);
      });
    } else if (['CheckBox'].includes(fieldToBeCloned?.Type)) {
      Array.from(html.getElementsByTagName('input'))?.forEach(
        (checkboxTarget) => {
          const optTextVal = (checkboxTarget?.nextSibling as Text).data;
          const activeOpt = newCloneOptions?.find(
            (o) => o?.OptionText === optTextVal
          );
          if (activeOpt?.UniqueID)
            checkboxTarget.setAttribute('id', `Checkbox_${activeOpt.UniqueID}`);
        }
      );
    }
    const modifiedHtmlStr = html.body.innerHTML;
    return modifiedHtmlStr;
  }
}
